var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add-or-update',{attrs:{"pageType":"add"}})
}
var staticRenderFns = []

export { render, staticRenderFns }